import { RoomMassAddActionTypes, RoomMassAddState, ROOM_MASS_ADD_DATA_FAILURE, ROOM_MASS_ADD_DATA_REQUEST, ROOM_MASS_ADD_DATA_SUCCESS } from "store/reducers/room/massAdd/types";

const defaultState: RoomMassAddState = {
  isLoading: false,
  errorMessage: ""
};

export default function roomMassAdd(state = defaultState, action: RoomMassAddActionTypes): RoomMassAddState {
  switch (action.type) {
    case ROOM_MASS_ADD_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ROOM_MASS_ADD_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_MASS_ADD_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};